import assignWith from 'lodash/assignWith';
import set from 'lodash/set';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
var languages = ['en', 'zh-CN'];
var detector = new LanguageDetector();
var isServerSide = typeof window === 'undefined';
if (!isServerSide) {
    detector.addDetector({
        name: 'userAgent',
        lookup: function () {
            var match = navigator.userAgent.match(/language\/([a-zA-Z'-_]+)/i);
            if (match) {
                return match[1].replace('_', '-');
            }
            return undefined;
        },
    });
}
var translationMap = {
    avatar: ['Avatar', '头像'],
    ok: ['OK', '确定'],
    cancel: ['Cancel', '取消'],
    select: ['Select', '请选择'],
    search: ['Search', '搜索选项'],
    hour: ['H', '时'],
    minute: ['M', '分'],
    second: ['S', '秒'],
    now: ['Now', '此刻'],
    inputHour: ['Input Hour', '输入小时'],
    inputMinute: ['Input Minute', '输入分'],
    inputSecond: ['Input Second', '输入秒'],
    close: ['Close', '关闭'],
    loadingFailed: ['Loading Failed', '加载失败'],
    noOptions: ['No Options', '暂无选项'],
    copySuccessed: ['Copy Succeeded', '复制成功'],
    copyFailed: ['Copy Failed', '复制失败'],
    eyedropper: ['Eyedropper', '取色器'],
    eyedropperFailedSafari: [
        'Eyedropper is not supported by this browser. Please open it in Chrome',
        '取色器暂不支持本浏览器, 请在 Chrome 中使用',
    ],
    eyedropperFailedEdge: [
        'Eyedropper is not supported by this browser. Please open it in Chrome',
        '取色器暂不支持本浏览器, 请在 Chrome 中使用',
    ]
};
var resources = {};
languages.forEach(function (lang, index) {
    var translation = assignWith({}, translationMap, function (objectValue, sourceValue) { return sourceValue[index]; });
    set(resources, [lang, 'translation'], translation);
});
var i18nInstance = i18next.createInstance();
i18nInstance.use(detector).init({
    resources: resources,
    fallbackLng: {
        'zh-TW': ['zh-HK', 'zh-CN'],
        default: ['zh-CN'],
    },
    detection: {
        order: ['querystring', 'userAgent', 'cookie'],
        lookupCookie: 'language',
        caches: [],
    },
});
export function i18n(key) {
    return i18nInstance.t(key);
}
